<template>
    <transition name="fade">
        <scrolly class="sidebar" v-if="value.stato" :style="{ width: '25vw', height: 'calc(100vh - 56px)' }">
            <scrolly-viewport style="padding: 10px">
                <b-card no-body class="mb-1">
                    <b-card-header header-tag="header" class="p-1" role="tab">
                        <b-container>
                            <b-row>
                                <b-col><p style="margin-bottom: 0"><font-awesome-icon icon="search" /> Ricerca</p></b-col>
                                <b-col></b-col>
                            </b-row>
                        </b-container>
                    </b-card-header>
                    <b-card-body>
                        <b-form-input v-model="sidebar.ricerca" type="text" placeholder="Ragione sociale o CF"></b-form-input>
                        <hr v-if="data.aziende.length > 0">
                        <scrolly v-if="data.aziende.length > 0" :style="{ width: '100%', height: '200px' }">
                            <scrolly-viewport>
                                <b-list-group v-for="(value, index) in data.aziende" :key="index">
                                    <b-list-group-item href="#" v-on:click="setAzienda(value)">
                                        <p style="margin-bottom: 0">{{value.ragione}} ({{value.zona}})</p>
                                        <p style="margin-bottom: 0"><small>{{value.cf}}</small></p>
                                        <p style="margin-bottom: 0"><small>{{value.com_ind}}, {{value.comune}}</small></p>
                                        <p style="margin-bottom: 0"><small>{{value.categoria}}</small></p>
                                        <p style="margin-bottom: 0"><small>{{value.sottocategoria}}</small></p>
                                    </b-list-group-item>
                                </b-list-group>
                            </scrolly-viewport>
                            <scrolly-bar axis="y"></scrolly-bar>
                            <scrolly-bar axis="x"></scrolly-bar>
                        </scrolly>
                    </b-card-body>
                </b-card>
                <div role="tablist">
                    <b-card no-body class="mb-1">
                    <b-card-header header-tag="header" class="p-1" role="tab" v-b-toggle.b1>
                        <b-container>
                            <b-row>
                                <b-col><p style="margin-bottom: 0"><font-awesome-icon icon="map-marker-alt" /> Zone</p></b-col>
                                <b-col><p style="margin-bottom: 0">{{nomeZona}}</p></b-col>
                            </b-row>
                        </b-container>
                    </b-card-header>
                    <b-collapse id="b1" accordion="my-accordion" role="tabpanel">
                        <b-card-body>
                            <b-form-select v-model="sidebar.zona" :options="data.zona.data" value-field="id" text-field="nome" class="mb-3"></b-form-select>
                            <hr>
                            <b-button size="sm" variant="outline-info" style="float: right; margin-bottom: 10px" v-b-toggle.b2>Avanti</b-button>
                            <b-button size="sm" variant="outline-danger" style="float: left; margin-bottom: 10px" v-on:click="sidebar.zona = 0">Cancella filtro</b-button>
                        </b-card-body>
                    </b-collapse>
                    </b-card>

                    <b-card no-body class="mb-1">
                    <b-card-header header-tag="header" class="p-1" role="tab" v-b-toggle.b2>
                        <b-container>
                            <b-row>
                                <b-col><p style="margin-bottom: 0"><font-awesome-icon icon="calendar-alt" /> Periodo</p></b-col>
                                <b-col><div v-if="sidebar.anno1 || sidebar.trimestre1" style="float: left">{{sidebar.anno1}}/Q{{sidebar.trimestre1}}</div><div v-if="sidebar.anno2 || sidebar.trimestre2" style="float: right">{{sidebar.anno2}}/Q{{sidebar.trimestre2}}</div></b-col>
                            </b-row>
                        </b-container>
                    </b-card-header>
                    <b-collapse id="b2" accordion="my-accordion" role="tabpanel">
                        <b-card-body>
                            <b-form-select v-model="sidebar.anno1" :options="data.anno.data" class="mb-3"></b-form-select>
                            <b-form-select v-model="sidebar.trimestre1" :options="data.trimestre" class="mb-3"></b-form-select>
                            <hr>
                            <b-form-select v-model="sidebar.anno2" :options="data.anno.data" class="mb-3"></b-form-select>
                            <b-form-select v-model="sidebar.trimestre2" :options="data.trimestre" class="mb-3"></b-form-select>
                            <hr>
                            <b-button size="sm" variant="outline-info" style="float: right; margin-bottom: 10px" v-b-toggle.b3>Avanti</b-button>
                            <b-button size="sm" variant="outline-danger" style="float: left; margin-bottom: 10px" v-on:click="sidebar.anno1 = sidebar.anno2 = sidebar.trimestre1 = sidebar.trimestre2 = null">Cancella filtri</b-button>
                        </b-card-body>
                    </b-collapse>
                    </b-card>

                    <b-card no-body class="mb-1">
                    <b-card-header header-tag="header" class="p-1" role="tab" v-b-toggle.b3>
                        <b-container>
                            <b-row>
                                <b-col cols="4"><p style="margin-bottom: 0"><font-awesome-icon icon="tags" /> Categoria</p></b-col>
                                <b-col cols="8"><p v-if="sidebar.categoria || sidebar.sottocategoria" style="width: 100%; margin-bottom: 0; font-size: 12px; overflow: hidden; white-space: nowrap; text-overflow: ellipsis;">{{nomeCategoria}} --- {{nomeSottocategoria}}</p></b-col>
                            </b-row>
                        </b-container>
                    </b-card-header>
                    <b-collapse id="b3" accordion="my-accordion" role="tabpanel">
                        <b-card-body>
                            <b-form-select v-model="sidebar.categoria" :options="data.categoria.data" value-field="id" text-field="nome" class="mb-3"></b-form-select>
                            <b-form-select v-model="sidebar.sottocategoria" :options="data.sottocategoria" value-field="id" text-field="nome" class="mb-3"></b-form-select>
                            <hr>
                            <b-button size="sm" variant="outline-info" style="float: right; margin-bottom: 10px" v-b-toggle.b4>Avanti</b-button>
                            <b-button size="sm" variant="outline-danger" style="float: left; margin-bottom: 10px" v-on:click="sidebar.categoria = sidebar.sottocategoria = null">Cancella filtri</b-button>
                        </b-card-body>
                    </b-collapse>
                    </b-card>

                    <b-card no-body class="mb-1">
                    <b-card-header header-tag="header" class="p-1" role="tab" v-b-toggle.b4>
                        <b-container>
                            <b-row>
                                <b-col><p style="margin-bottom: 0"><font-awesome-icon icon="euro-sign" /> Ricavi</p></b-col>
                                <b-col><p v-if="sidebar.ricavi" style="margin-bottom: 0">{{data.ricavi[sidebar.ricavi].text}}</p></b-col>
                            </b-row>
                        </b-container>
                    </b-card-header>
                    <b-collapse id="b4" accordion="my-accordion" role="tabpanel">
                        <b-card-body>
                            <b-form-select v-model="sidebar.ricavi" :options="data.ricavi" class="mb-3"></b-form-select>
                            <hr>
                            <b-button size="sm" variant="outline-info" style="float: right; margin-bottom: 10px" v-b-toggle.b5>Avanti</b-button>
                            <b-button size="sm" variant="outline-danger" style="float: left; margin-bottom: 10px" v-on:click="sidebar.ricavi = null">Cancella filtro</b-button>
                        </b-card-body>
                    </b-collapse>
                    </b-card>

                    <b-card no-body class="mb-1">
                    <b-card-header header-tag="header" class="p-1" role="tab" v-b-toggle.b5>
                        <b-container>
                            <b-row>
                                <b-col><p style="margin-bottom: 0"><font-awesome-icon icon="file-alt" /> Criterio</p></b-col>
                                <b-col><p v-if="sidebar.criterio" style="margin-bottom: 0">Dati omogenei</p></b-col>
                            </b-row>
                        </b-container>
                    </b-card-header>
                    <b-collapse id="b5" accordion="my-accordion" role="tabpanel">
                        <b-card-body>
                            <b-form-checkbox v-model="sidebar.criterio">Dati omogenei</b-form-checkbox>
                            <hr>
                            <b-button size="sm" variant="outline-info" style="float: right; margin-bottom: 10px" v-b-toggle.b6>Avanti</b-button>
                            <b-button size="sm" variant="outline-danger" style="float: left; margin-bottom: 10px" v-on:click="sidebar.criterio = false">Cancella filtro</b-button>
                        </b-card-body>
                    </b-collapse>
                    </b-card>

                    <b-card no-body class="mb-1">
                    <b-card-header header-tag="header" class="p-1" role="tab" v-b-toggle.b6>
                        <b-container>
                            <b-row>
                                <b-col><p style="margin-bottom: 0"><font-awesome-icon icon="city" /> Azienda</p></b-col>
                                <b-col><p style="width: 100%; margin-bottom: 0; font-size: 12px; overflow: hidden; white-space: nowrap; text-overflow: ellipsis;">{{sidebar.azienda.ragione}}</p></b-col>
                            </b-row>
                        </b-container>
                    </b-card-header>
                    <b-collapse id="b6" accordion="my-accordion" role="tabpanel">
                        <b-card-body>
                            <p v-if="!sidebar.azienda.ragione">Non è stata selezionata nessuna azienda.</p>
                            <div v-else>
                                <p style="margin-bottom: 0">{{sidebar.azienda.ragione}} ({{sidebar.azienda.zona}})</p>
                                <p style="margin-bottom: 0"><small>{{sidebar.azienda.cf}}</small></p>
                                <p style="margin-bottom: 0"><small>{{sidebar.azienda.com_ind}}, {{sidebar.azienda.comune}}</small></p>
                                <p style="margin-bottom: 0"><small>{{sidebar.azienda.categoria}}</small></p>
                                <p style="margin-bottom: 0"><small>{{sidebar.azienda.sottocategoria}}</small></p>
                            </div>
                            <hr>
                            <b-button size="sm" variant="info" style="float: right; margin-bottom: 10px" v-on:click="modalAziendeFiltrate()">
                                <div class="spinner">
                                    <p v-if="listenModalAziende">Caricamento in corso</p>
                                    <p v-else style="margin-right: 0 !important">Aziende filtrate</p>
                                    <div class="bounce1" v-if="listenModalAziende"></div>
                                    <div class="bounce2" v-if="listenModalAziende"></div>
                                    <div class="bounce3" v-if="listenModalAziende"></div>
                                </div>
                            </b-button>
                            <b-button size="sm" variant="outline-danger" style="float: left; margin-bottom: 10px" v-on:click="sidebar.azienda = {}">Cancella filtro</b-button>
                        </b-card-body>
                    </b-collapse>
                    </b-card>
                </div>
                <b-card no-body class="mb-1">
                    <b-card-header header-tag="header" class="p-1" role="tab">
                        <b-container>
                            <b-row>
                                <b-col><p style="margin-bottom: 0"><font-awesome-icon icon="table"/> Dati Statistici</p></b-col>
                                <b-col></b-col>
                            </b-row>
                        </b-container>
                    </b-card-header>
                    <b-card-body>
                        <b-table :sort-by.sync="sortBy"
                                :sort-desc.sync="sortDesc"
                                :items="$sidebarValue.info.items"
                                :fields="$sidebarValue.info.fields">
                        </b-table>
                    </b-card-body>
                </b-card>
                <br>
                <b-button size="lg" variant="outline-danger" style="float: left;" v-on:click="reset()">Cancella filtri</b-button>
                <b-button size="lg" variant="success" style="float: right;" v-on:click="cerca()">Applica filtri</b-button>

                <b-modal v-model="modalAziende" size="lg" title="Lista aziende filtrate" style="z-index: 999;">
                    <b-form-group horizontal label="Cerca:" class="mb-0">
                        <b-input-group>
                            <b-form-input v-model="filter" placeholder="Cerca" />
                            <b-input-group-append>
                                <b-btn :disabled="!filter" @click="filter = ''">X</b-btn>
                            </b-input-group-append>
                        </b-input-group>
                    </b-form-group>

                    <b-table show-empty
                        stacked="md"
                        :items="$sidebarValue.listaAziende"
                        :fields="fieldsAziende"
                        :current-page="currentPage"
                        :per-page="7"
                        :filter="filter"
                        @filtered="onFiltered"
                        style="margin-top: 10px"
                    >
                        <template slot="actions" slot-scope="row">
                            <b-button variant="info" size="sm" @click.stop="setAzienda(row.item)" v-on:click="modalAziende = false">Seleziona</b-button>
                        </template>
                    </b-table>

                    <b-row>
                        <b-col md="6" class="my-1">
                            <b-pagination :total-rows="totalRows" :per-page="7" v-model="currentPage" class="my-0" />
                        </b-col>
                    </b-row>

                    <div slot="modal-footer" class="w-100">
                        <b-btn class="float-right" variant="primary" @click="modalAziende = false">Chiudi</b-btn>
                    </div>
                </b-modal>
                </scrolly-viewport>
            <scrolly-bar axis="y"></scrolly-bar>
            <scrolly-bar axis="x"></scrolly-bar>
        </scrolly>
    </transition>
</template>

<script>
import Vue from 'vue'
import { Scrolly, ScrollyViewport, ScrollyBar } from 'vue-scrolly'
import {ricavi as ricaviG} from '../config.global'

export default {
    name: 'sidebar',
    props: ['value'],
    components: {
        Scrolly,
        ScrollyViewport,
        ScrollyBar
    },
    data() {
        return {
            sid: this.$sidebar,
            sidebar: this.$sidebarValue,
            data: Vue.prototype.$sidebarData,
            sortBy: 'n',
            sortDesc: false,
            settingAzienda: false,

            modalAziende: false,
            fieldsAziende: [
                {key: 'ragione', label: 'Azienda', sortable: true, 'class': 'col-tab-modal'},
                {key: 'zona', label: 'Zona', sortable: true, 'class': 'col-tab-modal'},
                {key: 'cf', label: 'Codice fiscale', sortable: true, 'class': 'col-tab-modal'},
                {key: 'categoria', label: 'Categoria', sortable: true, 'class': 'col-tab-modal'},
                {key: 'sottocategoria', label: 'Sottocategoria', sortable: true, 'class': 'col-tab-modal'},
                {key: 'actions', label: ''}
            ],
            currentPage: 1,
            filter: '',
            totalRows: this.$sidebarValue.listaAziende.length,
            listenModalAziende: false
        }
    },
    watch: {
        'sidebar.categoria':{
            handler: function (val, oldVal) {
                if(!this.settingAzienda)
                    this.sidebar.sottocategoria = null
                
                this.settingAzienda = false
                this.setSottocategoria(val)
            },
            deep: true
        },
        'sidebar.trimestre1':{
            handler: function (val, oldVal) {
                this.setRicavi(val)
            },
            deep: true
        },
        'sidebar.ricerca':{
            handler: function (val, oldVal) {
                if(val.length > 2)
                    this.ricerca(val)
                else
                    this.data.aziende = []
            }
        },
        'sid.trovatoAziende':{
            handler: function (val, oldVal) {
                this.listenModalAziende = false
                this.modalAziende = true
            }
        }
    },
    mounted: function () {
        this.setZona()
        this.setCategoria()
        this.setAnni()
    },
    computed: {
        nomeZona: function () {
            for(var i=0; i<this.data.zona.data.length; i++){
                if(this.sidebar.zona == this.data.zona.data[i].id)
                    return this.data.zona.data[i].nome
            }
        },
        nomeCategoria(){
            for(var i=0; i<this.data.categoria.data.length; i++){
                if(this.sidebar.categoria == this.data.categoria.data[i].id)
                    return this.data.categoria.data[i].nome
            }
        },
        nomeSottocategoria(){
            if(this.sidebar.sottocategoria == null)
                return null
            else
                for(var i=0; i<this.data.sottocategoria.length; i++){
                    if(this.sidebar.sottocategoria == this.data.sottocategoria[i].id)
                        return this.data.sottocategoria[i].nome
                }
        }
    },
    methods: {
        setZona(){
            if(!this.data.zona.loaded)
                Vue.http.post(this.$hostlink+'sidebar/list/zone', {}, {credentials : true}).then(response => {
                    var data = [{ id: 0, nome: 'Tutte le zone' }]
                    data = data.concat(response.body)
                    this.data.zona.data = data
                    this.data.zona.loaded = true
                    //Vue.prototype.$sidebarData.zona = this.data.zona
                })
        },
        setAnni(){
            if(!this.data.anno.loaded)
                Vue.http.post(this.$hostlink+'sidebar/list/anni', {}, {credentials : true}).then(response => {
                    var data = [{ value: null, text: 'Selezionare un anno' }]
                    data = data.concat(response.body)
                    this.data.anno.data = data
                    this.data.anno.loaded = true
                    //Vue.prototype.$sidebarData.categoria = this.data.categoria
                })
        },
        setCategoria(){
            if(!this.data.categoria.loaded)
                Vue.http.post(this.$hostlink+'sidebar/list/categoria', {}, {credentials : true}).then(response => {
                    var data = [{ id: null, nome: 'Selezionare una categoria' }]
                    data = data.concat(response.body)
                    this.data.categoria.data = data
                    this.data.categoria.loaded = true
                    //Vue.prototype.$sidebarData.categoria = this.data.categoria
                })
        },
        setSottocategoria(id){
            if(id != null){
                Vue.http.post(this.$hostlink+'sidebar/list/sottocategoria', {id: id}, {credentials : true}).then(response => {
                    var data = [{ id: null, nome: 'Selezionare una sottocategoria' }]
                    data = data.concat(response.body)
                    this.data.sottocategoria = data
                    //Vue.prototype.$sidebarData.sottocategoria = this.data.sottocategoria
                })
            }else{
                var data = [{ id: null, nome: '' }]
                this.data.sottocategoria = data
                //Vue.prototype.$sidebarData.sottocategoria = this.data.sottocategoria
            }
        },
        setRicavi(trimestre){
            if(trimestre == null)
                trimestre = 1
            this.data.ricavi = [{ value: null, text: 'Selezionare un range' },
                { value: 1, text: this.formatNumber(ricaviG[0][0]*trimestre)+' - '+this.formatNumber(ricaviG[0][1]*trimestre) },
                { value: 2, text: this.formatNumber(ricaviG[1][0]*trimestre)+' - '+this.formatNumber(ricaviG[1][1]*trimestre) },
                { value: 3, text: this.formatNumber(ricaviG[2][0]*trimestre)+' in su' }]
        },
        formatNumber(n){
            return new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(n)
        },
        reset(){
            this.sidebar.ricerca = ''
            this.sidebar.zona = 0 
            this.sidebar.anno1 = null
            this.sidebar.anno2 = null
            this.sidebar.trimestre1 = null
            this.sidebar.trimestre2 = null
            this.sidebar.categoria = null
            this.sidebar.sottocategoria = null
            this.sidebar.ricavi = null
            this.sidebar.criterio = false
            this.sidebar.azienda = {}
            this.sidebar.info = []

            Vue.prototype.$sidebarValue = this.sidebar

            Vue.prototype.$sidebar.cerca = !this.$sidebar.cerca
            this.$emit('input', this.$sidebar)
        },
        cerca(){
            Vue.prototype.$sidebar.cerca = !this.$sidebar.cerca
            this.$emit('input', this.$sidebar)
        },
        ricerca(val){
            Vue.http.post(this.$hostlink+'sidebar/list/aziende', {ricerca: val}, {credentials : true}).then(response => {
                this.data.aziende = response.body
            })
        },
        setAzienda(value){
            this.data.aziende = []
            this.sidebar.ricerca = ''
            this.sidebar.azienda = value

            this.settingAzienda = true

            this.sidebar.zona = value.zid
            this.sidebar.categoria = value.cid
            this.sidebar.sottocategoria = value.sid

            this.sidebar.ricavi = value.ricavi || null
            this.sidebar.anno1 = value.anno1 || null
            this.sidebar.anno2 = value.anno2 || null
            this.sidebar.trimestre1 = value.trimestre1 || null
            this.sidebar.trimestre2 = value.trimestre2 || null

            Vue.prototype.$sidebarValue = this.sidebar
            Vue.prototype.$sidebar.cerca = !this.$sidebar.cerca
            this.$emit('input', this.$sidebar)
        },
        modalAziendeFiltrate(){
            Vue.prototype.$sidebar.cercaAziende = !this.$sidebar.cercaAziende
            this.$emit('input', this.$sidebar)
            this.listenModalAziende = true
        },
        onFiltered (filteredItems) {
            this.totalRows = filteredItems.length
            this.currentPage = 1
        }
    }
}
</script>

<style>
.sidebar{
    top: 0;
    left: 0;
    float: left;
}

.col-tab-modal{
    padding: 20px;
    width: 140px;
    max-width: 140px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    font-size: 13px;
}

/*.fade-enter-active, .fade-leave-active {
  transform: translate(0, 100%);
  transition: all .3s ease;
}*/
.fade-enter, .fade-leave-to {
  transform: translate(-100%, 0);
}

.box-form{
    margin: 10px 0 10px 0 !important;
    box-shadow:  1px  1px 5px #dedede, 
              -1px -1px 5px #dedede,
               1px -1px 5px #dedede,
              -1px  1px 5px #dedede;
}

.mb-1{
    margin: 0 !important;
    box-shadow:  1px  1px 5px #dedede, 
              -1px -1px 5px #dedede,
               1px -1px 5px #dedede,
              -1px  1px 5px #dedede;
}

/*CSS loader animated*/
.spinner {
  /*margin: 100px auto 0;*/
  /*width: 70px;*/
  text-align: center;
}

.spinner > div {
  width: 5px;
  height: 5px;
  background-color: white;

  border-radius: 100%;
  display: inline-block;
  -webkit-animation: sk-bouncedelay 1.4s infinite ease-in-out both;
  animation: sk-bouncedelay 1.4s infinite ease-in-out both;
}

.spinner > p {
  margin: 0;
  float: left;
}

.spinner .bounce1 {
  -webkit-animation-delay: -0.32s;
  animation-delay: -0.32s;
}

.spinner .bounce2 {
  -webkit-animation-delay: -0.16s;
  animation-delay: -0.16s;
}

@-webkit-keyframes sk-bouncedelay {
  0%, 80%, 100% { -webkit-transform: scale(0) }
  40% { -webkit-transform: scale(1.0) }
}

@keyframes sk-bouncedelay {
  0%, 80%, 100% { 
    -webkit-transform: scale(0);
    transform: scale(0);
  } 40% { 
    -webkit-transform: scale(1.0);
    transform: scale(1.0);
  }
}
</style>
